import { render, staticRenderFns } from "./payperprocedure.vue?vue&type=template&id=be813bd2&scoped=true&"
import script from "./payperprocedure.vue?vue&type=script&lang=ts&"
export * from "./payperprocedure.vue?vue&type=script&lang=ts&"
import style0 from "./payperprocedure.vue?vue&type=style&index=0&id=be813bd2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "be813bd2",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VProgressCircular } from 'vuetify/lib/components/VProgressCircular';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSubheader } from 'vuetify/lib/components/VSubheader';
installComponents(component, {VCol,VContainer,VProgressCircular,VRow,VSubheader})
